var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { actionClass } from "@ane/legacy/lib/decorators/ReduxDecorators";
import mdsDataplaneResource from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import { getExperimentationGroupIdFromPath } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ConfigSnapshotActions = class {
  reset() {
    return void 0;
  }
  getSnapshots(workspaceId, section) {
    return __async(this, null, function* () {
      return yield mdsDataplaneResource.getSnapshots(workspaceId, section);
    });
  }
  getDefaultSnapshot(workspaceId, section) {
    return __async(this, null, function* () {
      return yield mdsDataplaneResource.getDefaultSnapshot(workspaceId, section);
    });
  }
  getSelectedMergeMode(workspaceId, section, snapshot) {
    return __async(this, null, function* () {
      return yield mdsDataplaneResource.getMergeMode(workspaceId, section, snapshot);
    });
  }
  getSnapshotUpdateStatus(workspaceId, section, snapshot) {
    return __async(this, null, function* () {
      if (snapshot) {
        const snapshotUpdateStatus = yield mdsDataplaneResource.getSnapshotUpdateStatus(workspaceId, section, snapshot);
        return snapshotUpdateStatus;
      }
    });
  }
  setSection(request, mgPath) {
    return __async(this, null, function* () {
      const experimentationGroup = getExperimentationGroupIdFromPath(request.workspaceId, mgPath);
      request.experimentationGroup = experimentationGroup;
      const newSnapshotName = yield mdsDataplaneResource.setSection(request);
      return newSnapshotName;
    });
  }
  selectSnapshot(activeItem) {
    return activeItem;
  }
};
ConfigSnapshotActions = __decorateClass([
  actionClass("admin_app_module")
], ConfigSnapshotActions);
const configSnapshotActions = new ConfigSnapshotActions();
export {
  ConfigSnapshotActions,
  configSnapshotActions as default
};
//# sourceMappingURL=ConfigSnapshotActions.js.map
